import { render, staticRenderFns } from "./materialSel.vue?vue&type=template&id=f2380254&scoped=true&"
import script from "./materialSel.vue?vue&type=script&lang=js&"
export * from "./materialSel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2380254",
  null
  
)

export default component.exports